<template>
	<div v-loading="loading" class="goods-channel-config">
		<el-collapse v-model="tierCollapse" class="tier-collapse">
			<el-collapse-item name="tier">
				<template slot="title">
					<span class="tier-collapse-title">
						阶梯毛利润配置
						<span v-if="isManualRule" class="tier-collapse-note">不适用（规则类型：手工指定）</span>
					</span>
				</template>
				<div v-if="isManualRule" class="tier-empty">当前规则类型为手工指定，无需配置阶梯毛利润。</div>
				<div v-else class="tier-table" :class="{ 'tier-table--readonly': isShopSharedConfigReadonly }">
					<div class="tier-row tier-row--head" :class="{ 'tier-row--readonly': isShopSharedConfigReadonly }">
						<span>代理价区间 (元)</span>
						<span>毛利润 (%)</span>
						<span v-if="!isShopSharedConfigReadonly">操作</span>
					</div>
					<div v-for="(item, index) in form.tierList" :key="item._uid" class="tier-row" :class="{ 'tier-row--readonly': isShopSharedConfigReadonly }">
						<div class="tier-range">
							<el-input-number v-model="item.priceMin" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="代理价(元)" size="small" />
							<span class="range-sep">&lt;=代理价(元)&lt;</span>
							<el-input-number v-model="item.priceMax" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="代理价(元)" size="small" />
						</div>
						<el-input-number v-model="item.profitRate" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="毛利润(%)" size="small" />
						<button v-if="!isShopSharedConfigReadonly" type="button" class="text-link" @click="onRemoveTier(index)">删除</button>
					</div>
					<button v-if="!isShopSharedConfigReadonly" type="button" class="text-link tier-add" @click="onAddTier">+ 新增阶梯</button>
				</div>
			</el-collapse-item>
		</el-collapse>

		<el-form v-if="showRuleConfigForm" ref="form" :model="form" :rules="rules" label-width="0" class="config-form">
			<div class="config-panel" :class="{ 'config-panel--readonly': isShopSharedConfigReadonly }">
				<div class="field-grid">
					<div class="field-item">
						<label>单款尺码毛利润 (%)</label>
						<el-input-number v-model="form.grossProfit" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>渠道不支持退货代理价加点 (%)</label>
						<el-input-number v-model="form.nonReturnMarkup" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>不退仓最大折扣</label>
						<el-input-number v-model="form.nonReturnDiscount" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>拼多多扣点数 (%)</label>
						<el-input-number v-model="form.pddDeduction" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>运费</label>
						<el-input-number v-model="form.postage" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>配货率 (%)</label>
						<el-input-number v-model="form.allocationRate" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>准时率 (%)</label>
						<el-input-number v-model="form.onTimeRate" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>预发日期</label>
						<el-select v-model="form.shipDays" :disabled="isShopSharedConfigReadonly" placeholder="请选择" size="small">
							<el-option v-for="item in shipDateOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
					</div>
					<div class="field-item">
						<label>保价天数</label>
						<el-input-number v-model="form.priceProtectDays" :min="0" :precision="0" :step="1" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0" size="small" />
					</div>
					<div class="field-item">
						<label>价格上涨不更新价格(%)，范围内</label>
						<el-input-number v-model="form.priceUpInRange" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>价格下跌不更新价格(%)，范围内</label>
						<el-input-number v-model="form.priceDownInRange" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>价格上涨不更新价格(%)，范围外</label>
						<el-input-number v-model="form.priceUpOutRange" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<div class="field-item">
						<label>价格下跌不更新价格(%)，范围外</label>
						<el-input-number v-model="form.priceDownOutRange" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="0.00" size="small" />
					</div>
					<template v-if="isSafetyStockRule">
						<div class="field-item">
							<label>单买价加价金额(元)</label>
							<el-input-number v-model="form.singleBuyMarkup" :min="0" :precision="2" :controls="false" :disabled="isShopSharedConfigReadonly" placeholder="1.00" size="small" />
						</div>
					</template>
					<template v-if="isSafetyStockProductRule">
						<div class="field-item">
							<label>安全折扣</label>
							<el-input-number v-model="form.safetyDiscount" :min="0" :precision="2" :step="0.01" :controls="false" placeholder="10.00" size="small" />
							<span v-if="safetyDiscountHint" class="field-hint">{{ safetyDiscountHint }}</span>
						</div>
					</template>
				</div>

				<div class="radio-section">
					<div class="radio-item">
						<label>撕防伪</label>
						<el-radio-group v-model="form.securityStatus" :disabled="isShopSharedConfigReadonly" size="mini" class="radio-compact">
							<el-radio label="all">全部</el-radio>
							<el-radio label="tear">撕防伪</el-radio>
							<el-radio label="no_tear">不撕防伪</el-radio>
						</el-radio-group>
					</div>
					<div class="radio-item radio-item--policy">
						<label>退货政策</label>
						<el-radio-group v-model="form.returnPolicy" :disabled="isShopSharedConfigReadonly" size="mini" class="radio-compact">
							<el-radio label="none">不做控制</el-radio>
							<el-radio label="exclude0_100">自动匹配渠道时，不匹配退货政策 0%+100% 的渠道</el-radio>
							<el-radio label="only100_0">自动匹配渠道时，只匹配退货政策 100%+0% 的渠道</el-radio>
						</el-radio-group>
					</div>
					<div class="radio-item">
						<label>渠道集</label>
						<el-radio-group v-model="form.channelSet" :disabled="isShopSharedConfigReadonly" size="mini" class="radio-compact">
							<el-radio label="all">全部</el-radio>
							<el-radio label="mandatory_backup">必选渠道+备选渠道</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div>
		</el-form>

		<div class="rule-bar">
			<div class="rule-bar__label">规则类型</div>
			<el-radio-group v-model="syncRule" size="mini" class="rule-radio radio-compact" @change="onSyncRuleChange">
				<el-radio v-for="item in syncRuleOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
			</el-radio-group>
			<div class="rule-bar__actions">
				<el-button type="primary" size="small" :loading="matching" :disabled="isManualRule" @click="onMatchChannels">按规则匹配渠道</el-button>
				<el-button type="primary" size="small" plain :loading="saving" :disabled="isShopSharedConfigReadonly" @click="onSaveAll">保存全部</el-button>
			</div>
		</div>

		<div class="page-tips">
			<p>提示：渠道背景为灰色标识一般渠道；绿色标识必选渠道；红色标识不支持拼多多快递，不会推送库存；黑色标识黑名单渠道</p>
			<p>提示：安全折扣是当渠道折扣高于设定的折扣时，代理认为折扣太高，不适合销售。一般建议设置为8折，就是渠道折扣超过8,就不再计算库存上架。各代理可以根据自身店铺情况进行设置</p>
			<p>提示：鼠标移到渠道库存的单元格中，会提示不推送此渠道库存的原因，合计值0不展示</p>
		</div>

		<div v-if="!channelBlocks.length" class="channel-empty">暂无渠道库存数据</div>
		<div v-for="(block, blockIndex) in channelBlocks" :key="blockIndex + '-' + syncRule" class="channel-block">
			<div class="channel-layout" :class="{ 'channel-layout--with-product': block.product }">
				<div v-if="block.product" class="channel-product-side">
					<div class="product-side-inner">
						<div v-if="block.product.pic" class="product-side-pic">
							<img :src="block.product.pic" alt="">
						</div>
						<div v-if="block.product.style_number" class="product-side-item"><span>型号</span>{{ block.product.style_number }}</div>
						<div v-if="block.product.brand" class="product-side-item"><span>品牌</span>{{ block.product.brand }}</div>
						<div v-if="block.product.category" class="product-side-item"><span>分类</span>{{ block.product.category }}</div>
						<div v-if="block.product.series" class="product-side-item"><span>系列</span>{{ block.product.series }}</div>
						<div v-if="block.product.gender" class="product-side-item"><span>性别</span>{{ block.product.gender }}</div>
						<div v-if="block.product.color" class="product-side-item"><span>颜色</span>{{ block.product.color }}</div>
						<div v-if="block.product.weight" class="product-side-item"><span>重量</span>{{ block.product.weight }}</div>
						<div v-if="block.product.season" class="product-side-item"><span>发布季</span>{{ block.product.season }}</div>
						<div v-if="block.product.price" class="product-side-item"><span>价格</span>{{ block.product.price }}</div>
					</div>
				</div>
				<div class="channel-table-wrap">
				<el-table
					:data="block.tablelist"
					border
					size="mini"
					class="channel-table"
					:cell-class-name="cellClassName"
					:span-method="function(opts) { return tableSpanMethod(opts, block) }"
				>
					<el-table-column prop="shop_name" label="尺寸" min-width="88" fixed="left" align="center">
						<template slot-scope="scope">
							<div class="channel-first-cell">
								<span
									v-if="scope.row._legend || isChannelDataRow(scope.row)"
									class="channel-checkbox-slot"
								>
									<el-checkbox
										v-if="scope.row._legend"
										v-model="scope.row._checked"
										:indeterminate="scope.row._indeterminate"
										class="channel-row-checkbox"
										@change="onLegendCheckChange(blockIndex, scope.row, $event)"
									/>
									<el-checkbox
										v-else-if="isChannelDataRow(scope.row)"
										v-model="scope.row._checked"
										class="channel-row-checkbox"
										@change="onChannelDataCheckChange(blockIndex)"
									/>
								</span>
								<span v-if="scope.row._legend" class="channel-legend-label">渠道/组</span>
								<span v-else-if="scope.row._summary" class="summary-label">{{ scope.row.shop_name }}</span>
								<span v-else class="channel-name-text">{{ scope.row.shop_name }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						v-for="size in block.sizes"
						:key="size.id"
						:prop="'size_' + size.id"
						min-width="58"
						align="center"
					>
						<template slot="header">
							<div>{{ size.size }}</div>
						</template>
						<template slot-scope="scope">
							<p
								v-if="scope.row._legend && block.sizes.length && size.id === block.sizes[0].id"
								class="row-hint-text channel-legend-desc"
							>{{ getRowHintText(scope.row) }}</p>
							<template v-else-if="scope.row._summary && isEditableSummaryCell(scope.row)">
								<el-input
									v-model="scope.row['size_' + size.id]"
									size="mini"
									class="cell-input"
									:placeholder="getSummaryCellPlaceholder(scope.row._rowType)"
									@blur="onSummaryCellInput(blockIndex, scope.row._rowType, size.id, scope.row)"
								/>
							</template>
							<template v-else-if="scope.row._summary">
								<span class="summary-value">{{ formatSummaryCellValue(scope.row, scope.row['size_' + size.id]) }}</span>
							</template>
							<span
								v-else
								:class="{ 'size-cell-clickable': isManualRule && isChannelDataRow(scope.row) }"
								@click="onManualSizeCellClick(scope.row, size.id)"
							>
								<el-tooltip
									v-if="scope.row['size_' + size.id + '_tip']"
									:content="scope.row['size_' + size.id + '_tip']"
									placement="top"
								>
									<span>{{ formatDisplayNumber(scope.row['size_' + size.id]) }}</span>
								</el-tooltip>
								<span v-else>{{ formatDisplayNumber(scope.row['size_' + size.id]) }}</span>
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="stock" label="合计" min-width="52" align="center">
						<template slot-scope="scope">
							<p
								v-if="scope.row._legend && !block.sizes.length"
								class="row-hint-text channel-legend-desc"
							>{{ getRowHintText(scope.row) }}</p>
							<p v-else-if="hasMetricRowHint(scope.row)" class="row-hint-text">{{ getRowHintText(scope.row) }}</p>
							<span v-else>{{ formatStockTotal(scope.row.stock) }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="product_price" label="零售价" min-width="68" align="center">
						<template slot-scope="scope">{{ scope.row._summary ? '' : formatDisplayNumber(scope.row.product_price) }}</template>
					</el-table-column>
					<el-table-column prop="true_discount" label="折扣" min-width="58" align="center">
						<template slot-scope="scope">{{ scope.row._summary ? '' : formatDecimal(scope.row.true_discount) }}</template>
					</el-table-column>
					<el-table-column prop="agent_price" label="综合代理价/代理价" min-width="108" align="center">
						<template slot-scope="scope">{{ scope.row._summary ? '' : formatAgentPrice(scope.row.agent_price) }}</template>
					</el-table-column>
					<el-table-column prop="stop_take_time" label="截单" min-width="68" align="center">
						<template slot-scope="scope">{{ scope.row._summary ? '' : scope.row.stop_take_time }}</template>
					</el-table-column>
					<el-table-column prop="prev_send_delivery_date" label="预发" min-width="78" align="center">
						<template slot-scope="scope">{{ scope.row._summary ? '' : scope.row.prev_send_delivery_date }}</template>
					</el-table-column>
					<el-table-column prop="free_return_rate" label="退货比+扣款" min-width="96" align="center">
						<template slot-scope="scope">{{ scope.row._summary ? '' : scope.row.free_return_rate }}</template>
					</el-table-column>
					<el-table-column prop="allocation_rate" label="配货率" min-width="68" align="center">
						<template slot-scope="scope">{{ scope.row._summary ? '' : scope.row.allocation_rate }}</template>
					</el-table-column>
					<el-table-column prop="on_time_rate" label="准时率" min-width="68" align="center">
						<template slot-scope="scope">{{ scope.row._summary ? '' : scope.row.on_time_rate }}</template>
					</el-table-column>
					<el-table-column prop="security" label="撕防伪" min-width="72" align="center">
						<template slot-scope="scope">{{ scope.row._summary ? '' : formatSecurity(scope.row.security) }}</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="库存更新" min-width="88" align="center">
						<template slot-scope="scope">{{ scope.row._summary || scope.row._legend ? '' : scope.row.create_time_str }}</template>
					</el-table-column>
					<el-table-column v-if="showBatchColumn" label="批量配置" min-width="108" fixed="right" align="center">
						<template slot-scope="scope">
							<div v-if="showBatchPriceApply && scope.row._rowType === 'single_price'" class="batch-price-cell">
								<el-input
									v-model="batchPriceMap[blockIndex + '_single']"
									size="mini"
									class="cell-input cell-input--batch"
									placeholder="批量"
								/>
								<button type="button" class="text-link" @click="applyBatchPrice(blockIndex, 'single_price')">应用</button>
							</div>
							<div v-else-if="showBatchPriceApply && scope.row._rowType === 'group_price'" class="batch-price-cell">
								<el-input
									v-model="batchPriceMap[blockIndex + '_group']"
									size="mini"
									class="cell-input cell-input--batch"
									placeholder="批量"
								/>
								<button type="button" class="text-link" @click="applyBatchPrice(blockIndex, 'group_price')">应用</button>
							</div>
							<div v-else-if="isSafetyStockProductRule && scope.row._rowType === 'safety_stock'" class="batch-price-cell">
								<el-input
									v-model="batchPriceMap[blockIndex + '_stock']"
									size="mini"
									class="cell-input cell-input--batch"
									placeholder="批量"
								/>
								<button type="button" class="text-link" @click="applyBatchSafetyStock(blockIndex)">应用</button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	buildChannelConfigSavePayload,
	fetchChannelPushConfig,
	isConfigSourceChannelMatchRule,
	isManualChannelRule,
	isShopSharedConfigReadonly,
	mapChannelTableData,
	mapPushConfigToForm,
	matchGoodsChannelsByRule,
	saveChannelPushConfig,
	saveGoodsSyncRule,
} from './detailed/retailGoodsChannelConfig'
import { validateProfitTierList } from './detailed/retailShopPushConfig'
import { appendChannelLegendRow, calcMaxAgentPrice, normalizePriceValue } from './detailed/channelConfigTableMock'

const SAFETY_DISCOUNT_ROW_HINT = '安全折扣是当渠道折扣高于设定的折扣时，代理认为折扣太高，不适合销售。一般建议设置为8折，就是渠道折扣超过8，就不再计算库存上架。各代理可以根据自身店铺情况进行设置'

const MAX_AGENT_PRICE_HINT_FIXED = '最高代理价=拼团价-拼团价*(毛利润/100)-拼团价*(扣点数/100)-运费，适用一口价选渠道规则'

const MAX_AGENT_PRICE_HINT_SAFETY_STOCK = '最高代理价=代理价'

const CHANNEL_LEGEND_HINT = '可用库存/订单锁定库存，库存=可用库存+订单锁定库存，如订单锁定库存为0则不显示/订单锁定库存'

const METRIC_HINT_COLUMN_COUNT = 10

let nextTierUid = 1

const createTierRow = () => ({
	_uid: nextTierUid++,
	priceMin: undefined,
	priceMax: undefined,
	profitRate: undefined,
})

const DEFAULT_FORM = {
	grossProfit: 6,
	nonReturnMarkup: 0,
	nonReturnDiscount: 0,
	pddDeduction: 0,
	postage: 10,
	allocationRate: 90,
	onTimeRate: 86,
	shipDays: 3,
	returnPolicy: 'only100_0',
	securityStatus: 'all',
	channelSet: 'all',
	priceProtectDays: 0,
	priceUpInRange: 0,
	priceDownInRange: 0,
	priceUpOutRange: 0,
	priceDownOutRange: 0,
	singleBuyMarkup: 1,
	safetyDiscount: 10,
	tierList: [],
}

export default {
	name: 'PddGoodsChannelConfig',
	inject: {
		retailShop: { default: null },
	},
	data() {
		return {
			loading: false,
			saving: false,
			matching: false,
			tierCollapse: ['tier'],
			syncRule: '',
			form: Object.assign({}, DEFAULT_FORM, { tierList: Array.from({ length: 2 }, createTierRow) }),
			stockCategories: [],
			channelBlocks: [],
			batchPriceMap: {},
			rules: {},
			syncRuleOptions: [
				{ value: 'manual', label: '手工指定' },
				{ value: 'fixed_price_channel_shop', label: '一口价渠道-通用规则' },
				{ value: 'fixed_price_channel_product', label: '一口价渠道-单独规则' },
				{ value: 'safety_stock_price_shop', label: '通用安全库存规则改价格' },
				{ value: 'safety_stock_price_product', label: '单独安全库存规则改价格' },
			],
			shipDateOptions: [
				{ value: 1, label: '当日发货' },
			].concat(Array.from({ length: 14 }, (_, i) => ({
				value: i + 2,
				label: `${i + 2}日内发货`,
			}))),
		}
	},
	computed: {
		productId() {
			return (this.retailShop && this.retailShop.channelConfigProductId) || ''
		},
		isManualRule() {
			return this.syncRule === 'manual'
		},
		isFixedPriceRule() {
			return this.syncRule === 'fixed_price_channel_shop' || this.syncRule === 'fixed_price_channel_product'
		},
		isSafetyStockRule() {
			return this.syncRule === 'safety_stock_price_shop' || this.syncRule === 'safety_stock_price_product'
		},
		isSafetyStockProductRule() {
			return this.syncRule === 'safety_stock_price_product'
		},
		isShopSharedConfigReadonly() {
			return isShopSharedConfigReadonly(this.syncRule)
		},
		showRuleConfigForm() {
			return !this.isManualRule
		},
		showBatchColumn() {
			return this.isFixedPriceRule || this.isSafetyStockProductRule || this.isManualRule
		},
		showBatchPriceApply() {
			return this.isFixedPriceRule || this.isManualRule
		},
		productMeta() {
			const row = this.retailShop && this.retailShop.channelConfigRow
			if (!row) {
				return {}
			}
			return {
				style_number: row.goods_id || row.style_number || '',
				brand: row.brand || '',
				color: row.color || '',
				price: row.price || row.product_price || 699,
				pic: row.pic || row.thumb_url || row.image_url || '',
			}
		},
		safetyDiscountHint() {
			const val = this.form.safetyDiscount
			if (val == null || val === '') {
				return ''
			}
			const formatted = this.formatDecimal(val)
			if (Number(val) >= 10) {
				return '安全折扣: ' + formatted + '(不打折，商品原价)'
			}
			return '安全折扣: ' + formatted + '(' + formatted + '折)'
		},
		configFetchKey() {
			return (this.retailShop && this.retailShop.channelConfigKey) || ''
		},
	},
	watch: {
		configFetchKey: {
			immediate: true,
			handler(key) {
				if (key) {
					this.fetchConfig()
				}
			},
		},
	},
	methods: {
		onAddTier() {
			this.form.tierList.push(createTierRow())
		},
		onRemoveTier(index) {
			this.form.tierList.splice(index, 1)
		},
		formatSecurity(value) {
			if (value == 2 || value === 'tear') {
				return '撕防伪'
			}
			if (value == 3 || value === 'no_tear') {
				return '不撕防伪'
			}
			return '未设置'
		},
		formatDecimal(value, precision) {
			var digits = precision == null ? 2 : precision
			if (value == null || value === '') {
				return digits === 0 ? '0' : Number(0).toFixed(digits)
			}
			var num = Number(value)
			if (isNaN(num)) {
				return value
			}
			return num.toFixed(digits)
		},
		formatDisplayNumber(value) {
			if (value == null || value === '') {
				return '0'
			}
			const num = Number(value)
			if (isNaN(num)) {
				return value
			}
			return String(Math.round(num))
		},
		formatSummaryCellValue(row, value) {
			if (row && row._rowType === 'safety_discount') {
				return this.formatDecimal(value)
			}
			return this.formatDisplayNumber(value)
		},
		formatStockTotal(value) {
			if (value == null || value === '' || Number(value) === 0) {
				return ''
			}
			return this.formatDisplayNumber(value)
		},
		formatAgentPrice(value) {
			if (value == null || value === '') {
				return ''
			}
			var self = this
			return String(value).split('/').map(function(part) {
				return self.formatDecimal(part)
			}).join('/')
		},
		getSummaryRowHint(row) {
			if (!row || !row._summary) {
				return ''
			}
			if (row._rowType === 'safety_discount') {
				return SAFETY_DISCOUNT_ROW_HINT
			}
			if (row._rowType === 'max_agent_price') {
				return this.isFixedPriceRule ? MAX_AGENT_PRICE_HINT_FIXED : MAX_AGENT_PRICE_HINT_SAFETY_STOCK
			}
			return ''
		},
		hasMetricRowHint(row) {
			return !!this.getSummaryRowHint(row)
		},
		getRowHintText(row) {
			if (row && row._legend) {
				return CHANNEL_LEGEND_HINT
			}
			return this.getSummaryRowHint(row)
		},
		getLegendRestColspan(block) {
			const sizeCount = block && block.sizes ? block.sizes.length : 0
			const batchOffset = this.showBatchColumn ? 1 : 0
			return sizeCount + METRIC_HINT_COLUMN_COUNT + 1 + batchOffset
		},
		tableSpanMethod({ row, columnIndex }, block) {
			const sizeCount = block && block.sizes ? block.sizes.length : 0
			const metricStart = 1 + sizeCount
			const metricEnd = metricStart + METRIC_HINT_COLUMN_COUNT - 1
			const legendRestColspan = this.getLegendRestColspan(block)

			if (row._legend) {
				if (columnIndex === 0) {
					return { rowspan: 1, colspan: 1 }
				}
				if (columnIndex === 1) {
					return { rowspan: 1, colspan: legendRestColspan }
				}
				if (columnIndex > 1 && columnIndex < 1 + legendRestColspan) {
					return { rowspan: 0, colspan: 0 }
				}
				return { rowspan: 1, colspan: 1 }
			}

			if (this.hasMetricRowHint(row)) {
				if (columnIndex === metricStart) {
					return { rowspan: 1, colspan: METRIC_HINT_COLUMN_COUNT }
				}
				if (columnIndex > metricStart && columnIndex <= metricEnd) {
					return { rowspan: 0, colspan: 0 }
				}
			}
			return { rowspan: 1, colspan: 1 }
		},
		isEditableSummaryCell(row) {
			if (!row || !row._summary) {
				return false
			}
			if (this.isManualRule || this.isFixedPriceRule) {
				return row._rowType === 'single_price' || row._rowType === 'group_price'
			}
			if (this.isSafetyStockProductRule) {
				return row._rowType === 'safety_stock'
			}
			return false
		},
		getSummaryCellPlaceholder(rowType) {
			if (rowType === 'single_price') {
				return '单买价'
			}
			if (rowType === 'group_price') {
				return '拼团价'
			}
			if (rowType === 'safety_stock') {
				return '库存'
			}
			return '请输入'
		},
		normalizeSummaryRowValues(blockIndex, rowType) {
			const block = this.channelBlocks[blockIndex]
			const row = this.findSummaryRow(block, rowType)
			if (!row || !block) {
				return
			}
			const sizes = block.sizes || []
			let i
			for (i = 0; i < sizes.length; i++) {
				const key = 'size_' + sizes[i].id
				row[key] = normalizePriceValue(row[key])
			}
		},
		findSummaryRow(block, rowType) {
			if (!block || !Array.isArray(block.tablelist)) {
				return null
			}
			return block.tablelist.find(function(row) {
				return row._summary && row._rowType === rowType
			}) || null
		},
		recalcMaxAgentPrice(blockIndex) {
			const block = this.channelBlocks[blockIndex]
			const groupRow = this.findSummaryRow(block, 'group_price')
			const maxRow = this.findSummaryRow(block, 'max_agent_price')
			if (!block || !groupRow || !maxRow) {
				return
			}
			const sizes = block.sizes || []
			let i
			for (i = 0; i < sizes.length; i++) {
				const key = 'size_' + sizes[i].id
				const groupPrice = groupRow[key]
				maxRow[key] = calcMaxAgentPrice(groupPrice, this.form.grossProfit, this.form.pddDeduction, this.form.postage)
				maxRow[key + '_select'] = 1
			}
		},
		onSummaryCellInput(blockIndex, rowType, sizeId, row) {
			const key = 'size_' + sizeId
			const normalized = normalizePriceValue(row[key])
			row[key] = normalized == null || normalized === '' ? 0 : normalized
			this.onSummaryCellChange(blockIndex, rowType)
		},
		onSummaryCellChange(blockIndex, rowType) {
			this.normalizeSummaryRowValues(blockIndex, rowType)
			if (rowType === 'group_price') {
				this.recalcMaxAgentPrice(blockIndex)
			}
		},
		applyBatchPrice(blockIndex, rowType) {
			if (!this.showBatchPriceApply) {
				return
			}
			const batchKey = blockIndex + '_' + (rowType === 'single_price' ? 'single' : 'group')
			const batchValue = normalizePriceValue(this.batchPriceMap[batchKey])
			if (batchValue == null || batchValue === '') {
				this.$message.warning('请输入批量价格')
				return
			}
			const block = this.channelBlocks[blockIndex]
			const row = this.findSummaryRow(block, rowType)
			if (!row || !block) {
				return
			}
			const sizes = block.sizes || []
			let i
			for (i = 0; i < sizes.length; i++) {
				const key = 'size_' + sizes[i].id
				row[key] = batchValue
				row[key + '_select'] = 1
			}
			if (rowType === 'group_price' && this.isFixedPriceRule) {
				this.recalcMaxAgentPrice(blockIndex)
			}
		},
		applyBatchSafetyStock(blockIndex) {
			const batchValue = normalizePriceValue(this.batchPriceMap[blockIndex + '_stock'])
			if (batchValue == null || batchValue === '') {
				this.$message.warning('请输入批量安全库存')
				return
			}
			const block = this.channelBlocks[blockIndex]
			const row = this.findSummaryRow(block, 'safety_stock')
			if (!row || !block) {
				return
			}
			const sizes = block.sizes || []
			let i
			for (i = 0; i < sizes.length; i++) {
				const key = 'size_' + sizes[i].id
				row[key] = batchValue
				row[key + '_select'] = 1
			}
		},
		loadTableBlocks(blocks) {
			this.channelBlocks = appendChannelLegendRow(blocks || [])
			this.initChannelRowChecks(this.channelBlocks)
			this.fillEmptySizeCells(this.channelBlocks)
		},
		fillEmptySizeCells(blocks) {
			if (!blocks || !blocks.length) {
				return
			}
			const vm = this
			blocks.forEach(function(block) {
				const sizes = block.sizes || []
				(block.tablelist || []).forEach(function(row) {
					if (row._legend || row._summary) {
						return
					}
					sizes.forEach(function(size) {
						const key = 'size_' + size.id
						if (row[key] == null || row[key] === '') {
							vm.$set(row, key, 0)
						}
					})
				})
			})
		},
		isChannelDataRow(row) {
			return !!(row && !row._summary && !row._legend)
		},
		onManualSizeCellClick(row, sizeId) {
			if (!this.isManualRule || !this.isChannelDataRow(row)) {
				return
			}
			const selectKey = 'size_' + sizeId + '_select'
			const nextSelected = row[selectKey] == 1 ? 0 : 1
			this.$set(row, selectKey, nextSelected)
		},
		initChannelRowChecks(blocks) {
			if (!blocks || !blocks.length) {
				return
			}
			const vm = this
			blocks.forEach(function(block) {
				(block.tablelist || []).forEach(function(row) {
					if (row._summary) {
						return
					}
					if (row._checked === undefined) {
						vm.$set(row, '_checked', false)
					}
					if (row._legend && row._indeterminate === undefined) {
						vm.$set(row, '_indeterminate', false)
					}
				})
			})
		},
		syncBlockChannelChecks(blockIndex, checked) {
			const block = this.channelBlocks[blockIndex]
			if (!block || !block.tablelist) {
				return
			}
			const vm = this
			block.tablelist.forEach(function(r) {
				if (!r._summary && !r._legend) {
					vm.$set(r, '_checked', checked)
				}
			})
		},
		onLegendCheckChange(blockIndex, row, checked) {
			const nextChecked = !!checked
			this.$set(row, '_indeterminate', false)
			this.$set(row, '_checked', nextChecked)
			this.syncBlockChannelChecks(blockIndex, nextChecked)
		},
		onChannelDataCheckChange(blockIndex) {
			const block = this.channelBlocks[blockIndex]
			if (!block || !block.tablelist) {
				return
			}
			const legend = block.tablelist.find(function(r) {
				return r._legend
			})
			if (!legend) {
				return
			}
			const channels = block.tablelist.filter(function(r) {
				return !r._summary && !r._legend
			})
			const checkedCount = channels.filter(function(r) {
				return r._checked
			}).length
			this.$set(legend, '_checked', checkedCount > 0 && checkedCount === channels.length)
			this.$set(legend, '_indeterminate', checkedCount > 0 && checkedCount < channels.length)
		},
		cellClassName({ row, column }) {
			const classes = []
			if (row._summary) {
				classes.push('summary-row-cell', 'summary-row-tall-cell')
			}
			if (row._legend) {
				classes.push('legend-row-cell', 'summary-row-tall-cell')
			}
			if (this.isChannelDataRow(row)) {
				classes.push('channel-data-row-cell')
			}
			if (row._legend && column.property && column.property.indexOf('size_') === 0) {
				classes.push('legend-merged-cell')
			}
			if (row._legend && column.property === 'stock') {
				classes.push('legend-merged-cell')
			}
			if (column.property === 'stock' && this.hasMetricRowHint(row)) {
				classes.push('hint-merged-cell')
			}
			if (column.property && column.property.indexOf('size_') === 0) {
				const selectKey = column.property + '_select'
				if (this.isChannelDataRow(row) && row[selectKey] == 1) {
					classes.push('size-selected')
				} else if (row._summary) {
					classes.push('size-summary')
				}
			}
			return classes.join(' ')
		},
		applyPushConfig(data, syncRule) {
			const mapped = mapPushConfigToForm(syncRule, data, createTierRow, 2)
			const form = Object.assign({}, DEFAULT_FORM, mapped.form || {})
			if (!form.tierList || !form.tierList.length) {
				form.tierList = Array.from({ length: 2 }, createTierRow)
			}
			this.form = form
			this.stockCategories = mapped.stockCategories || []
		},
		applyChannelBlocks(data, force) {
			const mapped = mapChannelTableData(data, this.syncRule)
			if (force || (mapped.channelBlocks && mapped.channelBlocks.length)) {
				this.loadTableBlocks(mapped.channelBlocks || [])
			}
		},
		resolveCurrentSyncRule(preferred) {
			if (preferred) {
				return preferred
			}
			const row = this.retailShop && this.retailShop.channelConfigRow
			if (row && row.sync_rule) {
				return row.sync_rule
			}
			return this.syncRule || 'none'
		},
		buildChannelMatchOptions() {
			return {
				withMatchParams: true,
				form: this.form,
				channelBlocks: this.channelBlocks,
			}
		},
		fetchConfig(overrideSyncRule) {
			if (!this.productId) {
				return
			}
			const syncRule = this.resolveCurrentSyncRule(overrideSyncRule)
			this.syncRule = syncRule
			const shopId = this.retailShop && this.retailShop.currentShopId
			this.loading = true
			fetchChannelPushConfig(this.$axios, syncRule, this.productId, shopId).then(function(data) {
				this.applyPushConfig(data, syncRule)
				if (isConfigSourceChannelMatchRule(syncRule) || isManualChannelRule(syncRule)) {
					return matchGoodsChannelsByRule(this.$axios, this.productId, syncRule).then(function(matchData) {
						this.applyChannelBlocks(matchData || {}, true)
					}.bind(this))
				}
				this.applyChannelBlocks(data)
			}.bind(this)).catch(function(err) {
				console.log(err)
				this.$message.error(err.message || '获取渠道配置失败')
				this.channelBlocks = []
			}.bind(this)).finally(function() {
				this.loading = false
			}.bind(this))
		},
		onSyncRuleChange(value) {
			if (value === 'safety_stock_price_shop' || value === 'safety_stock_price_product') {
				if (this.form.singleBuyMarkup == null || this.form.singleBuyMarkup === '') {
					this.form.singleBuyMarkup = 1
				}
			}
			if (value === 'safety_stock_price_product') {
				if (this.form.safetyDiscount == null || this.form.safetyDiscount === '') {
					this.form.safetyDiscount = 10
				}
			}
			if (this.retailShop && this.retailShop.channelConfigRow) {
				this.retailShop.channelConfigRow.sync_rule = value
			}
			this.channelBlocks = []
			this.batchPriceMap = {}
			this.fetchConfig(value)
		},
		onMatchChannels() {
			if (!this.productId) {
				return
			}
			this.matching = true
			matchGoodsChannelsByRule(
				this.$axios,
				this.productId,
				this.syncRule,
				this.buildChannelMatchOptions()
			).then(function(data) {
				this.$message.success('已按规则匹配渠道')
				this.applyChannelBlocks(data || {}, true)
			}.bind(this)).catch(err => {
				console.log(err)
				this.$message.error(err.message || '匹配渠道失败')
			}).finally(() => {
				this.matching = false
			})
		},
		onSaveAll() {
			if (!this.productId) {
				return
			}
			const doSave = () => {
				const shopId = this.retailShop && this.retailShop.currentShopId
				const saveResult = buildChannelConfigSavePayload(
					this.productId,
					shopId,
					this.syncRule,
					this.form,
					this.stockCategories,
					this.channelBlocks
				)
				this.saving = true
				const saveTasks = [saveChannelPushConfig(this.$axios, saveResult)]
				if (!this.isShopSharedConfigReadonly) {
					saveTasks.unshift(saveGoodsSyncRule(this.$axios, this.productId, this.syncRule))
				}
				Promise.all(saveTasks).then(() => {
					if (this.retailShop && this.retailShop.channelConfigRow) {
						this.retailShop.channelConfigRow.sync_rule = this.syncRule
					}
					this.$message.success('保存成功')
					this.fetchConfig()
				}).catch(err => {
					console.log(err)
					this.$message.error(err.message || '保存失败')
				}).finally(() => {
					this.saving = false
				})
			}
			if (this.isManualRule) {
				doSave()
				return
			}
			this.$refs.form.validate((valid) => {
				if (!valid) {
					return
				}
				const tierCheck = validateProfitTierList(this.form.tierList)
				if (!tierCheck.valid) {
					this.$message.warning(tierCheck.message)
					return
				}
				doSave()
			})
		},
	},
}
</script>

<style scoped lang="less">
.goods-channel-config {
	padding: 16px 18px 24px;
	font-size: 13px;
	color: #303133;
}

.tier-collapse {
	margin-bottom: 12px;
	border: none;

	/deep/ .el-collapse-item__header {
		height: 38px;
		line-height: 38px;
		font-size: 13px;
		color: #606266;
		background: #f7f8fa;
		border: 1px solid #eef0f3;
		border-radius: 6px;
		padding: 0 12px;
	}

	/deep/ .el-collapse-item__wrap {
		border: none;
	}

	/deep/ .el-collapse-item__content {
		padding: 10px 0 0;
	}
}

.tier-collapse-note {
	margin-left: 8px;
	font-size: 12px;
	color: #909399;
}

.tier-empty {
	padding: 8px 0;
	color: #909399;
	font-size: 12px;
}

.tier-table {
	border: 1px solid #eef0f3;
	border-radius: 6px;
	overflow: hidden;
}

.tier-row {
	display: grid;
	grid-template-columns: 1fr 120px 56px;
	gap: 8px;
	align-items: center;
	padding: 8px 10px;
	border-bottom: 1px solid #f0f2f5;
	font-size: 13px;

	&--head {
		background: #fafbfc;
		color: #909399;
		font-size: 12px;
	}

	&--readonly {
		grid-template-columns: 1fr 120px;
	}
}

.tier-range {
	display: flex;
	align-items: center;
	gap: 6px;
	flex-wrap: wrap;
}

.range-sep {
	color: #909399;
	font-size: 12px;
	white-space: nowrap;
}

.tier-add {
	margin: 8px 10px;
}

.config-panel {
	margin-bottom: 14px;
	padding: 12px;
	background: #fff;
	border: 1px solid #eef0f3;
	border-radius: 6px;

	&--readonly {
		background: #fafbfc;
	}
}

.field-grid {
	display: grid;
	grid-template-columns: repeat(5, minmax(0, 1fr));
	gap: 12px 14px;
}

.radio-section {
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 14px;
	padding-top: 14px;
	border-top: 1px solid #f0f2f5;
}

.radio-item {
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 0;

	label {
		font-size: 12px;
		color: #909399;
		line-height: 1.4;
		flex-shrink: 0;
	}

	&--policy {
		/deep/ .el-radio {
			display: flex;
			align-items: flex-start;
			white-space: normal;
		}
	}
}

.field-item {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;

	label {
		font-size: 12px;
		color: #909399;
		line-height: 1.4;
		min-height: 34px;
	}

	/deep/ .el-input-number,
	/deep/ .el-select {
		width: 100%;
	}

	/deep/ .el-input-number .el-input__inner,
	/deep/ .el-select .el-input__inner {
		height: 32px;
		line-height: 32px;
	}
}

.field-hint {
	font-size: 12px;
	color: #ff4714;
	line-height: 1.4;
}

.radio-compact {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 2px 0;

	/deep/ .el-radio {
		margin-right: 12px;
		margin-bottom: 2px;
		line-height: 1.4;
	}

	/deep/ .el-radio__label {
		font-size: 12px;
		padding-left: 5px;
		color: #606266;
	}

	/deep/ .el-radio__inner {
		width: 13px;
		height: 13px;

		&::after {
			width: 5px;
			height: 5px;
		}
	}
}

.rule-bar {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 10px 16px;
	padding: 12px;
	margin-bottom: 12px;
	background: #fafbfc;
	border: 1px solid #eef0f3;
	border-radius: 6px;

	&__label {
		font-size: 12px;
		color: #909399;
		flex-shrink: 0;
	}

	&__actions {
		margin-left: auto;
		display: flex;
		gap: 8px;
		flex-wrap: wrap;

		/deep/ .el-button--primary {
			background-color: #ff4714 !important;
			border-color: #ff4714 !important;
			color: #fff !important;

			&.is-plain {
				background-color: #fff !important;
				border-color: #ff4714 !important;
				color: #ff4714 !important;
			}

			&.is-plain:hover,
			&.is-plain:focus {
				background-color: #fff5f2 !important;
				border-color: #ff4714 !important;
				color: #ff4714 !important;
			}
		}
	}
}

.rule-radio {
	flex: 1;
	min-width: 0;
}

.page-tips {
	margin-bottom: 12px;
	padding: 8px 10px;
	background: #fff7f5;
	border-radius: 6px;

	p {
		margin: 0;
		font-size: 12px;
		line-height: 1.6;
		color: #c45656;

		+ p {
			margin-top: 4px;
		}
	}
}

.channel-empty {
	padding: 24px;
	text-align: center;
	color: #909399;
	font-size: 13px;
	background: #fafbfc;
	border-radius: 6px;
}

.channel-block {
	margin-bottom: 14px;
}

.channel-layout {
	display: grid;
	grid-template-columns: minmax(0, 1fr);
	align-items: stretch;
	border: 1px solid #eef0f3;
	border-radius: 6px;
	overflow: hidden;
	background: #fff;

	&--with-product {
		grid-template-columns: 132px minmax(0, 1fr);
	}
}

.channel-product-side {
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-height: 100%;
	padding: 8px;
	background: #fafbfc;
	border-right: 1px solid #eef0f3;
	font-size: 12px;
	color: #606266;
}

.product-side-inner {
	width: 100%;
}

.product-side-pic {
	width: 100%;
	height: 112px;
	margin-bottom: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
	border: 1px solid #eef0f3;
	border-radius: 4px;
	overflow: hidden;

	img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
}

.product-side-item {
	display: flex;
	flex-direction: column;
	gap: 1px;
	padding: 4px 0;
	border-bottom: 1px solid #f0f2f5;

	&:last-child {
		border-bottom: none;
	}

	span {
		color: #909399;
		font-size: 11px;
		line-height: 1.3;
	}
}

.channel-table-wrap {
	min-width: 0;
	min-height: 100%;
	display: flex;
	flex-direction: column;
	background: #fff;
	overflow: auto;
}

.channel-table {
	flex: 1;
	font-size: 11px;

	/deep/ &.el-table--border {
		border: none;
	}

	/deep/ &::before,
	/deep/ &::after {
		display: none;
	}

	/deep/ th {
		background: #f7f8fa !important;
		color: #909399;
		font-weight: 500;
		font-size: 11px;
		padding: 6px 4px !important;
	}

	/deep/ th .cell {
		line-height: 1.5;
		padding-top: 2px;
		padding-bottom: 2px;
		white-space: normal;
	}

	/deep/ td .cell {
		padding-left: 2px;
		padding-right: 2px;
		line-height: 1.5;
	}

	/deep/ td,
	/deep/ th {
		border-color: #ebeef5;
	}

	/deep/ td {
		padding: 6px 4px !important;
	}

	/deep/ .hint-merged-cell {
		text-align: left !important;

		.cell {
			text-align: left !important;
		}
	}

	/deep/ .size-selected {
		background: #fff7ed !important;
	}

	/deep/ .size-summary {
		background: #f7f8fa !important;
	}

	/deep/ .summary-row-cell {
		background: #fafbfc !important;

		.cell-input /deep/ .el-input__inner {
			background: #fff;
		}
	}

	/deep/ .summary-row-tall-cell,
	/deep/ .channel-data-row-cell {
		padding: 6px 4px !important;

		.cell {
			line-height: 1.5;
			white-space: normal;
		}
	}

	/deep/ .legend-row-cell {
		background: #fff !important;
	}

	/deep/ .legend-merged-cell {
		text-align: left !important;

		.cell {
			text-align: left !important;
			overflow: visible;
			white-space: normal;
		}
	}
}

.summary-label {
	font-weight: 500;
	color: #606266;
	font-size: 11px;
}

.channel-legend-label {
	font-size: 11px;
	color: #606266;
	font-weight: 500;
	white-space: nowrap;
}

.channel-legend-desc {
	text-align: left;
}

.row-hint-text {
	margin: 0;
	padding: 0 4px;
	font-size: 11px;
	line-height: 1.45;
	color: #909399;
	text-align: left;
	word-break: break-all;
}

.summary-value {
	color: #606266;
	font-size: 11px;
	font-variant-numeric: tabular-nums;
	line-height: 20px;
}

.size-cell-clickable {
	display: inline-block;
	width: 100%;
	cursor: pointer;
}

.summary-row-tall-cell .cell-input {
	/deep/ .el-input__inner {
		height: 22px;
		line-height: 22px;
	}
}

.channel-first-cell {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	min-height: 22px;
}

.channel-checkbox-slot {
	flex: 0 0 18px;
	width: 18px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.channel-name-text,
.channel-legend-label,
.summary-label {
	flex: 1;
	min-width: 0;
	text-align: center;
}

.channel-row-checkbox {
	margin: 0;

	/deep/ .el-checkbox__label {
		display: none;
		padding-left: 0;
	}

	/deep/ .el-checkbox__input {
		line-height: 1;
	}

	/deep/ .el-checkbox__inner {
		width: 14px;
		height: 14px;

		&::after {
			height: 7px;
			left: 4px;
			top: 1px;
			width: 3px;
		}
	}
}

.cell-input {
	width: 100%;
	max-width: 46px;

	/deep/ .el-input__inner {
		height: 18px;
		line-height: 18px;
		padding: 0 4px;
		text-align: center;
		font-size: 11px;
		color: #606266;
		border: 1px solid #dcdfe6;
		border-radius: 2px;
		box-sizing: border-box;
		background: #fff;

		&:hover {
			border-color: #c0c4cc;
		}

		&:focus {
			border-color: #ff4714;
		}
	}

	&--batch {
		max-width: 58px;
	}
}

.batch-price-cell {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 4px;
	flex-wrap: wrap;
}

.text-link {
	border: none;
	background: none;
	padding: 0;
	font-size: 12px;
	color: #2563eb;
	cursor: pointer;

	&:hover {
		text-decoration: underline;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/pddGoodsChannelConfig.vue